import { InboxTrackRow } from "../InboxTrackRow";
import LBox from "@components/LBox";
import { SectionTitle } from "../shared";
import { getTopTrackPerArtist } from "../../inboxPresentation";
import type {
  InboxSection,
  MusicRecommendationsPayload,
  OnPlayTrack,
} from "../types";

/**
 * "Recommended for you" — a list of track rows + copy + CTA, mirroring the
 * music_recommendations block of the weekly-digest email.
 */
export const MusicRecommendationsSection = ({
  section,
  onPlayTrack,
}: {
  section: InboxSection;
  onPlayTrack?: OnPlayTrack;
}) => {
  const { tracks } = section.payload as MusicRecommendationsPayload;
  const topTracks = getTopTrackPerArtist(tracks);

  return (
    <LBox gap="s3">
      <SectionTitle>{section.title}</SectionTitle>

      <LBox gap="s2">
        {topTracks.map((track) => (
          <InboxTrackRow
            key={track.songId}
            onPress={onPlayTrack ? () => onPlayTrack(track) : undefined}
            track={track}
          />
        ))}
      </LBox>
    </LBox>
  );
};
